'use client';

import { useSalePageQuery } from '@/entities/salePage/queries';
import { useCart } from '../../[salePageId]/contexts/CartContext';
import { DigitalPurchase } from '../bottomSheet/digital/DigitalPurchase';
import { ClassPurchase } from '../bottomSheet/physical/ClassPurchase';
import { PhysicalPurchase } from '../bottomSheet/physical/PhysicalPurchase';
import { CustomOrderFormCTA } from './CustomOrderFormCTA';

const SummaryOnSaleCTA = ({ salePageId }: { salePageId: number }) => {
  const { data: salePage } = useSalePageQuery(salePageId);
  const { cartItems, setCartItems } = useCart();

  if (!salePage) return null;

  const isCustomMediaProducts = salePage.hasCustomMediaProducts;

  const hasPhysical = salePage.products?.find(
    product => product.type === 'PHYSICAL' || product.type === 'FUNDING'
  );

  if (isCustomMediaProducts) {
    return <CustomOrderFormCTA salePage={salePage} />;
  }

  if (salePage.type === 'CLASS') {
    return <ClassPurchase salePage={salePage} />;
  }

  if (hasPhysical) {
    return (
      <PhysicalPurchase
        salePageId={salePage.id}
        cartItems={cartItems}
        setCartItems={setCartItems}
      />
    );
  }

  return <DigitalPurchase salePageId={salePage.id} data={salePage} />;
};

export default SummaryOnSaleCTA;
